import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'healthCode',
    standalone: false
})
export class HealthCodePipe implements PipeTransform {

  elements = [
    {
      code: 1,
      name: 'Ok',
      description: 'No problems, normal operation',
      color: 'var(--status-category-ok)',
      icon: 'far fa-check-circle'
    },
    {
      code: 2,
      name: 'Warning',
      description: 'Minor problems, but in safe operation mode',
      color: '#FFCC01',
      icon: 'far fa-exclamation-triangle'
    },
    {
      code: 3,
      name: 'Alarm',
      description: 'Severe problem, no operation possible',
      color: '#DF000F',
      icon: 'far fa-bell'
    }
  ];

  transform(value: number, key: string): string {
    const found = this.elements.find(el => el.code === value);

    if (found === undefined) {
      return '-';
    }

    return found[key];
  }

}
